import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../../services/api';
import { MessageSquare, Send, Plus, Bell } from 'lucide-react';
import toast from 'react-hot-toast';
import './Mensageria.css';

const Mensageria = () => {
  const [modalAberto, setModalAberto] = useState(false);
  const queryClient = useQueryClient();

  const { data: mensagens, refetch } = useQuery(
    'mensagens',
    async () => {
      const estabelecimento = queryClient.getQueryData('estabelecimento')?.data?.estabelecimento?._id;
      if (!estabelecimento) return { mensagens: [] };
      const response = await api.get(`/api/mensageria?estabelecimento=${estabelecimento}&lida=false`);
      return response.data.data;
    },
    {
      refetchInterval: 10000
    }
  );

  const marcarLidaMutation = useMutation(
    (id) => api.patch(`/api/mensageria/${id}/ler`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('mensagens');
      }
    }
  );

  const naoLidas = mensagens?.mensagens?.filter(m => !m.lida) || [];

  return (
    <div className="mensageria-page">
      <div className="page-header">
        <div>
          <h2><MessageSquare size={28} /> Mensageria Interna</h2>
          <p>Comunicação interna da equipe</p>
        </div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          {naoLidas.length > 0 && (
            <div className="badge-notificacao">
              <Bell size={20} />
              {naoLidas.length} nova(s)
            </div>
          )}
          <button className="btn btn-primary" onClick={() => setModalAberto(true)}>
            <Plus size={20} />
            Nova Mensagem
          </button>
        </div>
      </div>

      <div className="mensagens-lista">
        {mensagens?.mensagens?.map(mensagem => (
          <div
            key={mensagem._id}
            className={`mensagem-card ${mensagem.lida ? 'lida' : 'nao-lida'}`}
            onClick={() => !mensagem.lida && marcarLidaMutation.mutate(mensagem._id)}
          >
            <div className="mensagem-header">
              <div>
                <h3>{mensagem.assunto}</h3>
                <p>De: {mensagem.remetente?.nome}</p>
              </div>
              <div className="mensagem-meta">
                <span className="tipo-badge">{mensagem.tipo}</span>
                <span className="prioridade-badge prioridade-{mensagem.prioridade}">
                  {mensagem.prioridade}
                </span>
                {!mensagem.lida && <span className="badge-nova">Nova</span>}
              </div>
            </div>
            <p className="mensagem-texto">{mensagem.mensagem}</p>
            <span className="mensagem-data">
              {new Date(mensagem.createdAt).toLocaleString('pt-BR')}
            </span>
          </div>
        ))}
      </div>

      {modalAberto && (
        <ModalMensagem onClose={() => setModalAberto(false)} />
      )}
    </div>
  );
};

const ModalMensagem = ({ onClose }) => {
  const [formData, setFormData] = useState({
    assunto: '',
    mensagem: '',
    tipo: 'geral',
    prioridade: 'normal',
    destinatario: ''
  });
  const queryClient = useQueryClient();

  const sendMutation = useMutation(
    (data) => api.post('/api/mensageria', data),
    {
      onSuccess: () => {
        toast.success('Mensagem enviada!');
        queryClient.invalidateQueries('mensagens');
        onClose();
      }
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const estabelecimento = queryClient.getQueryData('estabelecimento')?.data?.estabelecimento?._id;
    sendMutation.mutate({
      ...formData,
      estabelecimento,
      destinatario: formData.destinatario || null
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Nova Mensagem</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Assunto</label>
            <input
              type="text"
              value={formData.assunto}
              onChange={(e) => setFormData({ ...formData, assunto: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Mensagem</label>
            <textarea
              value={formData.mensagem}
              onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
              rows={5}
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Tipo</label>
              <select
                value={formData.tipo}
                onChange={(e) => setFormData({ ...formData, tipo: e.target.value })}
              >
                <option value="geral">Geral</option>
                <option value="pedido">Pedido</option>
                <option value="estoque">Estoque</option>
                <option value="financeiro">Financeiro</option>
              </select>
            </div>
            <div className="form-group">
              <label>Prioridade</label>
              <select
                value={formData.prioridade}
                onChange={(e) => setFormData({ ...formData, prioridade: e.target.value })}
              >
                <option value="baixa">Baixa</option>
                <option value="normal">Normal</option>
                <option value="alta">Alta</option>
                <option value="urgente">Urgente</option>
              </select>
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              <Send size={20} />
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Mensageria;

